import { synthesisApi } from './synthesisApi';
import {
  SynthesisConfigurationResponse,
  SynthesisConfigurationCreate,
  SynthesisConfigurationUpdate,
} from '../types/synthesisConfig';

/**
 * Lista as configurações do Synthesis acessíveis ao usuário.
 * GET /configurations
 */
export async function listSynthesisConfigurations(): Promise<SynthesisConfigurationResponse[]> {
  const response = await synthesisApi.get<SynthesisConfigurationResponse[]>('/configurations');
  return response.data;
}

/**
 * Obtém detalhes de uma configuração específica do Synthesis.
 * GET /configurations/{cfgId}
 */
export async function getSynthesisConfiguration(cfgId: string): Promise<SynthesisConfigurationResponse> {
  const response = await synthesisApi.get<SynthesisConfigurationResponse>(`/configurations/${cfgId}`);
  return response.data;
}

/**
 * Cria uma nova configuração do Synthesis (apenas Admin).
 * POST /configurations
 */
export async function createSynthesisConfiguration(
  payload: SynthesisConfigurationCreate
): Promise<SynthesisConfigurationResponse> {
  const response = await synthesisApi.post<SynthesisConfigurationResponse>('/configurations', payload);
  return response.data;
}

/**
 * Atualiza uma configuração existente do Synthesis.
 * PUT /configurations/{cfgId}
 */
export async function updateSynthesisConfiguration(
  cfgId: string,
  payload: SynthesisConfigurationUpdate
): Promise<SynthesisConfigurationResponse> {
  // Filtra chaves com valor undefined antes de enviar
  const cleanedPayload = Object.entries(payload).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key as keyof SynthesisConfigurationUpdate] = value;
    }
    return acc;
  }, {} as SynthesisConfigurationUpdate);

  const response = await synthesisApi.put<SynthesisConfigurationResponse>(
    `/configurations/${cfgId}`,
    cleanedPayload
  );
  return response.data;
}